import { Component, ElementRef, ViewChild } from '@angular/core';
import { PageBase } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';


@Component({
  selector: 'Counting',
  templateUrl: './Counting.html',
})
export class CountingComponent extends PageBase {

  @ViewChild("tblCountings", { static: false }) tblCountings: T4DatatableWidget;

    constructor(el: ElementRef) {
        super(el, "OneWayAdmin");
  }

  public async startCounting() {
    await this.Api.get("OneWay/StartCounting");
    this.tblCountings.update(); 

    this.UI.snackBar("Inventering startad!");
  }



  public async openStartCountingMessageDialog() {

    const check = await this.Api.get("OneWay/CheckForActiveCounting");

    if (check) {
      var ret = await this.UI.openDialog<any>('T4.Messaging.SendMessage', {
        data: {
          type: "Counting", content: `<p> Hej på er! </p>

<p>Nu är det dags för månadens invertering. Detta är viktigt för både oss och er för att vagnparken ska stämma. </p>
<p>Vi vill att detta är klart senast torsdag eftermiddag så allt stämmer inför helgen. </p>
<p>Påminner som alltid om att inte gå på vad nycklarna säger utan att gå ut och kolla vilka vagnar ni har fysiskt, detta då nycklar ofta förväxlas. </p>


<p><i>Gör så här:</i></p>

<p>När inventeringen är startad kommer ni få en notis i T4. Denna ligger kvar tills ni har inventerat eller att inventeringstiden löpt ut.</p>
 
<p> Börja med att gå ut på gården och skriv ner vagnsnumren på de släp som står där. Fyll därefter i dem i resultat-fältet. </p>

<p>När du matat in alla vagnsnummer och klickat på ”Nästa” kontrolleras din inventering mot T4 och du får en lista på avvikelser. </p>

</br>
<a href="https://brenderuprental.zendesk.com/hc/en-us/articles/14153790938141">Guide - Registration of Oneway Inventory</a>

<p>Med vänliga hälsningar / Best regards </br>
Rental Teamet </p>

<p>
Brenderup AB </br>
Transportvägen 7 </br>
SE 556 50 Jönköping, Sweden 
</p>` }
      });

      if (ret) this.startCounting();
    }
    else {
      this.UI.snackBar("En inventering finns redan aktiv!");
    }
  }

}



